/** Runtime config for HTTP + AppSync clients (web, mobile). */
export type ShopgndApiConfig = {
  getIdToken: () => Promise<string | null>;
  /** Resolve a URL from amplify_outputs `custom` (e.g. adminOrdersUrl). */
  getCustomUrl: (key: string) => Promise<string | null>;
};

export async function fetchWithAuth(
  config: ShopgndApiConfig,
  url: string,
  init: RequestInit = {},
): Promise<Response> {
  const token = await config.getIdToken();
  if (!token) throw new Error('Not signed in.');
  return fetch(url, {
    ...init,
    headers: {
      ...(init.headers ?? {}),
      Authorization: `Bearer ${token}`,
      ...(init.body ? { 'Content-Type': 'application/json' } : {}),
    },
  });
}
